import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import { connectToStores } from 'fluxible-addons-react';
import UserStore from '../../stores/UserStore';
import styles from './styles.module.styl';
import CopyButton from './CopyButton';
import FeedbackSection from '../FeedbackSection';
import CodeBlockHeader from './Header';
import CodeHighlight from '../CodeHighlight';
import canUseStore from '../../util/canUseStore';
import * as defaults from '../../../lib/helpers/defaults';

/* eslint-disable react/no-danger */

class CodeBlock extends React.Component {
  handleUserValueChange = (action, event, selectedOpt) => {
    this.context.executeAction(action, { selectedId: selectedOpt.value });
  }

  handleCopyCode = throttle(
    () => {
      this.context.trackEvent('copy:code-snippet', {
        trackData: this.props.index
      });
    },
    5000,
    { trailing: false }
  )

  render() {
    const {
      code,
      children,
      tabPaneFooter,
      selectedClientId,
      selectedApiIdentifier,
      index
    } = this.props;

    // Only show the header if the client id or api id is present in the code
    const isClientIdInCode = code.includes(selectedClientId || defaults.CLIENT_ID);
    const isApiIdInCode = code.includes(selectedApiIdentifier || defaults.API_IDENTIFIER);
    const showHeader = isClientIdInCode || isApiIdInCode;

    return (
      <div className={styles.codeBlock}>
        {showHeader && <CodeBlockHeader
          isApiIdInCode={isApiIdInCode}
          isClientIdInCode={isClientIdInCode}
        >
          <CopyButton small code={code} />
        </CodeBlockHeader>}
        <div className={styles.codeSection}>
          {!showHeader && <CopyButton small code={code} />}
          <CodeHighlight>
            <pre
              className={styles.code}
              onCopy={this.handleCopyCode}
              dangerouslySetInnerHTML={{ __html: children }}
            />
          </CodeHighlight>
        </div>
        {tabPaneFooter && (
          <div
            className="tab-pane-footer"
            dangerouslySetInnerHTML={{ __html: tabPaneFooter }}
          />
        )}
        <FeedbackSection
          trackingCode="quickstarts:code-snippet"
          trackingData={index}
        />
      </div>
    );
  }
}

CodeBlock.contextTypes = {
  executeAction: PropTypes.func.isRequired,
  getStore: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired
};

CodeBlock.defaultProps = {
  tabPaneFooter: null
};

CodeBlock.propTypes = {
  children: PropTypes.node.isRequired,
  code: PropTypes.string.isRequired,
  tabPaneFooter: PropTypes.string,
  selectedClientId: PropTypes.string,
  selectedApiIdentifier: PropTypes.string,
  index: PropTypes.number
};

export default connectToStores(
  CodeBlock,
  [UserStore],
  (context) => {
    if (!canUseStore(context)) return {};
    const userStore = context.getStore(UserStore);

    return {
      selectedClientId: userStore.getSelectedClientId(),
      selectedApiIdentifier: userStore.getSelectedApiIdentifier()
    };
  }
);
